function useIsApplyV2FormEnabled(defaultValue?: boolean) {
    const input = document?.getElementById('__new_apply_form_enabled') as HTMLInputElement | null
    return input?.value === '1' || defaultValue
}

export default useIsApplyV2FormEnabled
